<template>
	<div>
		<section class="hero is-primary is-small" v-if="league">
			<div class="hero-body">
				<div class="container is-fullhd">
					<div class="media">
						<div class="media-left" v-if="league.logo_url">
							<div class="image is-96x96">
								<img class="is-rounded" :src="league.logo_url" />
							</div>
						</div>
						<div class="media-content">
							<h1 class="title">{{ league.name }}</h1>
							<h2 class="subtitle">
								{{ league.description }}<br />
								{{ league.season }}
							</h2>
						</div>
					</div>
				</div>
			</div>
		</section>

		<router-view />
	</div>
</template>

<script>
export default {
	computed: {
		league() {
			return this.$store.getters.activeLeague
		},
	},
	methods: {
		setLeague(leagueKey) {
			this.$store.dispatch("setActiveLeague", leagueKey)
		},
	},
	mounted() {
		this.setLeague(this.$route.params.leagueKey)
	},
	beforeRouteUpdate(to, from, next) {
		this.setLeague(to.params.leagueKey)
		next()
	},
}
</script>

<style scoped>
.media-content {
	/* match the image height in case the image doesn't exist, to keep the same height across leagues */
	min-height: 96px;
}
</style>
